import React from 'react';
import PropTypes from 'prop-types';

const TextViewControl = (props) => {
  let {labelText, value,} = props;
  return (<div className="form-group row">
      <label className="col-md-2 col-xs-3 col-sm-3 form-control-label">{labelText}</label>
      <div className="col-md-10 col-xs-10 col-sm-10 ">{value}</div>
    </div>);
};

TextViewControl.propTypes = {
    labelText: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
}

export default TextViewControl;